import {Component} from '@angular/core';
import {Node} from '../model/treeview/node';

@Component({
    selector:'simpleInput',
    template:`<div class="modal" [style.display]="!hide ? 'inline' : 'none'" style="margin : 20px; ">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- header-->
                <div class="modal-header">
                    <h4 class="modal-title"><span><img alt="icon" class="appWindow" src="../../../assets/images/091.png"></span>Name File Name</h4>
                </div>
                <div class="modalBodyContainer">
                    <div class="modal-body">
                        <!-- Texts -->
                        <div>
                            <input (change)="updateValue($event)">
                        </div>
                    </div>
                    <!-- footer-->
                    <div class="modal-footer ">
                        <button (click)="onOk()" class="btn btn-primary clickable hand" id="submit" type="button"><span
                                class="glyphicon glyphicon-ok"></span> {{'OK' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>`,
    styles:[`.modal-header{
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        background-color:dodgerblue;
        color:antiquewhite;
    }
    .modal-content{
        border-top-right-radius: 18px;
        border-top-left-radius: 18px;
    }
    .closeX{color:azure;size:25px;}
    .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
    .btn-danger:hover{background-color: #FF2400;}
    .appWindow{height:25px;margin-right:140px;}
    .genericIcon{height:90px;}


    /*new css*/

    .modal-title{margin-top: -6px;}
    .closeBtnH4{margin-top: -3px;}
    .appWindow {
        height: 35px;
    }
    .clientRow{background-color: #D0DFFE;}

    .led{width:22px;}

    .tableHeader{ background-image: url("../../assets/images/blueBack.jpg");}
    th{color:#ffffff;text-align: center;}

    .modalBodyContainer{
        padding-left: 3px;
        padding-right: 3px;
    }

    .modal-footer{background-color: #ECE8E5;border-top: groove;}
    .modal-body {
        width: 100%;
        padding: 0;
        overflow-y: auto;
        background-color: #ECE8E5;
    }
    .modal-body thead {
        position: sticky;
        top:0;
    }
    ::-webkit-scrollbar {
        width: 14px;
        height: 5px;
        background-color: #F5F3F0;
    }
    ::-webkit-scrollbar-thumb {
        height: 6px;
        border: 4px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        -webkit-border-radius: 7px;
        background-color:#BACEFF;
        -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
    }
    ::-webkit-scrollbar-button {
        width: 14px;
        height: 14px;
        display: none;
    }
    ::-webkit-scrollbar-corner {
        background-color: transparent;
    }

    .modal-dialog {
        margin: 50px auto auto;
        background-color: #0064FE;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }

    .modal-header {
        height:56px;
    //background-color: #0064FE;
        background-image: url("../../assets/images/headerBack.jpg");
        color: antiquewhite;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }

    .modal-content {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        background-color: #0064FE;
        padding-bottom: 3px;
    }`]
})
export class SimpleInputComponent {

    private hide= true;
    private node:Node = new Node('sample');
    onOk() {
        this.toggleModal();
    }

    toggleModal() {
        this.hide= !this.hide;
    }

    setNode(val:Node) {
        this.node = val;
    }


    updateValue(val: any) {
        this.node.setName(val.target.value);
    }
}
